/**
 * Mobile Menu Module
 * Handles hamburger toggle with blur+expand overlay animation.
 */
function initMobileMenu() {
  const hamburger = document.querySelector('.js-hamburger');
  const menu = document.getElementById('mobileMenu');

  if (!hamburger || !menu) return;

  function openMenu() {
    const bg = menu.querySelector('.mobile-menu__bg');

    if (bg) {
      bg.style.transition = 'none';
      bg.style.opacity = '1';
      bg.style.transform = 'translate(-50%, -50%) scale(0)';
      bg.getBoundingClientRect();
      bg.style.transition = 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1) 0.15s';
      bg.style.transform = 'translate(-50%, -50%) scale(1)';
    }

    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    hamburger.classList.add('is-active');
    hamburger.setAttribute('aria-expanded', 'true');
  }

  function closeMenu() {
    const bg = menu.querySelector('.mobile-menu__bg');
    const blur = menu.querySelector('.mobile-menu__blur');
    const nav = menu.querySelector('.mobile-menu__nav');
    const social = menu.querySelector('.mobile-menu__social');

    hamburger.classList.remove('is-active');
    hamburger.setAttribute('aria-expanded', 'false');

    // 0s: hide nav + social
    if (nav) {
      nav.style.transition = 'opacity 0.2s ease, transform 0.25s ease';
      nav.style.opacity = '0';
      nav.style.transform = 'translateY(-12px)';
    }
    if (social) {
      social.style.transition = 'opacity 0.2s ease, transform 0.25s ease';
      social.style.opacity = '0';
      social.style.transform = 'translateY(-8px)';
    }

    // 0.3s: fade out bg + blur — no movement
    setTimeout(() => {
      if (bg) {
        bg.style.transition = 'opacity 0.4s ease';
        bg.style.opacity = '0';
      }
      if (blur) {
        blur.style.transition = 'opacity 0.4s ease';
        blur.style.opacity = '0';
      }
    }, 300);

    // 0.75s: done — remove is-open and all inline styles
    setTimeout(() => {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      [nav, social, bg, blur].forEach((el) => {
        if (el) el.removeAttribute('style');
      });
    }, 750);
  }

  hamburger.addEventListener('click', (e) => {
    e.preventDefault();
    menu.classList.contains('is-open') ? closeMenu() : openMenu();
  });

  // Close on link click
  menu.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      const href = link.getAttribute('href');
      if (!href || href === '') return;
      closeMenu();
    });
  });
}
